import * as React from 'react';
import { I18n } from 'react-redux-i18n';

import FormatManagementBase, { FORMAT_MANAGEMENT_MODE } from '@common/components/FormatManagement';
import { getFolders, getFormats, deleteFolder, deleteFormat } from '../../actions/main';

import './format-management.styles.scss';

export const FormatManagement = (props) => {
  const { close, mode, onSubmit, onFolderCreate } = props;
  const [folders, setFolders] = React.useState([]);
  const [formats, setFormats] = React.useState([]);

  const handleGetFolders = React.useCallback(() => {
    return getFolders().then((folders) => {
      setFolders(folders);
    });
  }, []);

  const handleGetFormats = React.useCallback((folderId) => {
    return getFormats(folderId).then((formats) => {
      setFormats(formats);
    });
  }, []);

  const handleResetFormats = React.useCallback(() => {
    setFormats([]);
  }, []);

  const handleFolderCreate = React.useCallback((...args) => {
    return onFolderCreate(...args).then(handleGetFolders);
  }, [handleGetFolders]);

  const handleFolderDelete = React.useCallback((...args) => {
    return deleteFolder(...args).then(handleGetFolders);
  }, [handleGetFolders]);

  const handleFormatDelete = React.useCallback((folderId, formatId) => {
    return deleteFormat(formatId).then(() => {
      return handleGetFormats(folderId);
    });
  }, [handleGetFormats]);

  return (
    <FormatManagementBase 
      mode={mode}
      formats={formats}
      folders={folders}
      close={close}
      formatsTableColumns={[
        { label: I18n.t('Modified By'), field: 'createdBy' },
        { label: I18n.t('Last Modified'), field: 'createdDate' },
      ]}
      getFolders={handleGetFolders}
      getFormats={handleGetFormats}
      resetFormats={handleResetFormats}
      onFolderCreate={handleFolderCreate}
      onFolderDelete={handleFolderDelete}
      onFormatDelete={handleFormatDelete}
      onSubmit={onSubmit}
    />
  );
};

export {
  FORMAT_MANAGEMENT_MODE
}